var render, staticRenderFns
import script from "./PresentationEditorPPT.vue?vue&type=script&lang=js"
export * from "./PresentationEditorPPT.vue?vue&type=script&lang=js"
import style0 from "./PresentationEditorPPT.vue?vue&type=style&index=0&id=87fdb25a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fdb25a",
  null
  
)

export default component.exports